export let getWifiPackagesByLogout =
    {
        "result": true,
        "message": "SUCCESS",
        "data": [
            {
                "id": 1,
                "name_tr": "Sınırsız Internet",
                "name_en": "Unlimited Internet",
                "priceTL": 25,
                "priceUSD": 25,
                "packageNames": [],
                "packageInfos": [],
                "packageDescriptions": [],
                "packageInfoDescs": []
            },
            {
                "id": 2,
                "name_tr": "1 GB Internet",
                "name_en": "1 GB Internet",
                "priceTL": 20,
                "priceUSD": 20,
                "packageNames": [],
                "packageInfos": [],
                "packageDescriptions": [],
                "packageInfoDescs": []
            },
            {
                "id": 3,
                "name_tr": "500 MB Internet",
                "name_en": "500 MB Internet",
                "priceTL": 15,
                "priceUSD": 15,
                "packageNames": [],
                "packageInfos": [],
                "packageDescriptions": [],
                "packageInfoDescs": []
            },
            {
                "id": 4,
                "name_tr": "250 MB Internet",
                "name_en": "250 MB Internet",
                "priceTL": 9,
                "priceUSD": 9,
                "packageNames": [],
                "packageInfos": [],
                "packageDescriptions": [],
                "packageInfoDescs": []
            },
            {
                "id": 5,
                "name_tr": "Sınırsız Mesajlaşma",
                "name_en": "Unlimited Chat",
                "priceTL": 3,
                "priceUSD": 3,
                "packageNames": [],
                "packageInfos": [],
                "packageDescriptions": [],
                "packageInfoDescs": []
            }
        ],
        "jwt": null,
        "flightNumber": null
    };